import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { OperatorsTableService } from 'src/app/modules/acbcr/common/services/operators-table.service';
import { ReproductionsTableService } from 'src/app/modules/acbcr/common/services/reproductions-table.service';

@Component({
  selector: 'app-reproductie-insamantare-artificiala',
  templateUrl: './reproductie-insamantare-artificiala.component.html',
  styleUrls: ['./reproductie-insamantare-artificiala.component.scss']
})
export class ReproductieInsamantareArtificialaComponent {
  @Input() monta;
  @Input() form: UntypedFormGroup;
  @Input() field_errors;

  isSuperAdmin = false;
  isAdmin = false;
  isFermier = false;
  listaOperatori = [];
  listaFemele;
  listaTauri;
  disabledFields = {};
  exploatatieID;

  constructor(
    private helperDataService: HelperDataService,
    public operatorsTableService: OperatorsTableService,
    private reproductionsTableService: ReproductionsTableService,
  ) { }

  ngOnInit(): void {
    this.isSuperAdmin = UIHelper.isSuperAdmin();
    this.isAdmin = UIHelper.isAdmin();
    this.isFermier = UIHelper.isFermier();
  }

  ngOnChanges(changes) {
    if (changes.monta) {
      this.buildForm(this.monta);
    }
  }

  buildForm(formData?) {
    if (!formData) {
      formData = {};
    }

    this.form.addControl('operator_id', new UntypedFormControl(formData['operator_id']));
    this.form.addControl('data_insamantare', new UntypedFormControl(formData['data_insamantare']));
    this.form.addControl('nr_document', new UntypedFormControl(formData['nr_document']));
    this.form.addControl('file_name', new UntypedFormControl(formData['file_name']));
    this.form.addControl('file_id', new UntypedFormControl(formData['file_id']));
    this.form.addControl('taur_id', new UntypedFormControl(formData['taur_id']));
    this.form.addControl('rasa_id', new UntypedFormControl(formData['rasa_id']));
    this.form.addControl('femela_id', new UntypedFormControl(formData['femela_id']));

    this.exploatatieID = this.form.value.exploatatie_id || formData['exploatatie_id'];
    this.listaOperatori = formData['lista_operatori'];
    this.listaFemele = formData['lista_femele'];
    this.listaTauri = formData['lista_tauri'];
    this.disabledFields = formData['disabled_fields'] || {};
    this.field_errors = {};
  }

  dataMontaChange(event) {
    this.form.controls.data_insamantare.setValue(event);
    this.field_errors['data_insamantare'] = null;
    this.getListaTauri();
    this.getListaFemele();
  }

  searchOperator(event) {
    if (event.term.length < 4) {
      this.listaOperatori = [];
      return;
    }

    if (this.listaOperatori && this.listaOperatori.length) {
      return;
    }

    this.reproductionsTableService.getOperatorsAPI({ nume: event.term })
      .subscribe((response: any) => {
        this.listaOperatori = response || [];
      });
  }

  selectTaur(event) {
    let taurID = event ? event['id'] : null;
    let rasaID = event ? event['rasa_id'] : null;
    this.form.controls.taur_id.setValue(taurID);
    this.form.controls.rasa_id.setValue(rasaID);

    if (taurID) {
      this.field_errors['taur_id'] = null;
    }

    if (!event) {
      this.getListaTauri();
    }

    this.getListaFemele();
  }

  selectFemela(event) {
    this.field_errors['femela_id'] = null;

    if (!event) {
      this.getListaFemele();
    }
  }

  getListaFemele() {
    this.listaFemele = null;
    const dataInsamantare = this.form.value.data_insamantare;
    const rasaID = this.form.value.rasa_id;

    if (!this.exploatatieID || !rasaID || !dataInsamantare) {
      return;
    }

    let req_params = {
      exploatatie_id: this.exploatatieID,
      rasa_id: this.form.value.rasa_id,
      data: dataInsamantare,
    };

    this.reproductionsTableService.getVaci(req_params)
      .subscribe((response) => {
        this.listaFemele = response || [];

        let femelaGasita = this.listaFemele.find(
          (item) => item['id'] === this.form.value.femela_id
        );

        if (!femelaGasita) {
          this.form.controls.femela_id.reset();
        }
      });
  }

  getListaTauri() {
    this.listaTauri = null;

    if (!this.exploatatieID || !this.form.value.data_insamantare) {
      return;
    }

    let req_params = {
      data_insamantare: this.form.value.data_insamantare,
    };

    this.reproductionsTableService.getTauriIA(req_params)
      .subscribe((response) => {
        this.listaTauri = response || [];

        let taurGasit = this.listaTauri.find(
          (item) => item['id'] === this.form.value.taur_id
        );

        if (!taurGasit) {
          this.form.controls.taur_id.reset();
        }
      });
  }

  uploadInsamantareArtificiala(event) {
    if (event.body && event.body.files) {
      const file = event.body.files[0];
      this.form.controls.file_id.setValue(file.file_id);
      this.form.controls.file_name.setValue(file.file_uploaded_name);
      this.field_errors['file_id'] = null;
    }
  }

  downloadFile(event) {
    event.target.disabled = true;
    const fileId = this.form.value.file_id;
    const fileName = this.form.value.file_name;

    if (!fileId) {
      return;
    }

    this.helperDataService.downloadFile(fileId)
      .subscribe((response: any) => {
        const blob = new Blob([response]);
        this.helperDataService.simulateDownload(blob, fileName);
        event.target.disabled = false;
      });
  }

  deleteFile() {
    this.form.controls.file_id.reset();
    this.form.controls.file_name.reset();
  }

}
